import React, { memo } from 'react';
import './About.css';
import { aboutData } from '../../data/aboutData';
import MainVisual from '../../assets/image/output-onlinejpgtools.webp';

function About() {
  return (
    <section className="ab-section" id="about">
      <div className="ab-inner">

        {/* Visual */}
        <div className="ab-visual">
          <div className="ab-accent" />
          <div className="ab-dots" aria-hidden="true" />

          <div className="ab-img-wrap">
            <img
              src={MainVisual}
              alt="دکتر سیمین"
              loading="lazy"
              decoding="async"
            />
          </div>

          <div className="ab-card">
            <div className="ab-card-row">
              <span className="ab-card-num">20</span>
              <span className="ab-card-sup">+</span>
            </div>
            <span className="ab-card-label">Years of Excellence</span>
            <div className="ab-card-divider" />
            <div className="ab-card-row">
              <span className="ab-card-num">1K</span>
              <span className="ab-card-sup">+</span>
            </div>
            <span className="ab-card-label">Happy Clients</span>
          </div>
        </div>

        {/* Text */}
        <div className="ab-text">
          <div className="ab-watermark" aria-hidden="true">Dr.</div>
          <div className="ab-content">
            <p className="ab-eyebrow">Iran's Premier Beauty Authority</p>

            <h2 className="ab-name">
              <em>Dr.</em> Simin
            </h2>

            <hr className="ab-rule" />

            <blockquote className="ab-tagline">
              "{aboutData.description1}"
            </blockquote>

            <p className="ab-sub">{aboutData.description2}</p>

            <div className="ab-stats">
              <div className="ab-stat">
                <span className="ab-stat-num">20+</span>
                <span className="ab-stat-label">سال تجربه</span>
              </div>
              <div className="ab-stat">
                <span className="ab-stat-num">500+</span>
                <span className="ab-stat-label">محصول</span>
              </div>
              <div className="ab-stat">
                <span className="ab-stat-num">1K+</span>
                <span className="ab-stat-label">مشتری راضی</span>
              </div>
            </div>

            <a href="/about" className="ab-cta">
              بیشتر بدانید
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>
          </div>
        </div>

      </div>
    </section>
  );
}

export default memo(About);
